import { render, staticRenderFns } from "./Thg.vue?vue&type=template&id=150b5b06"
import script from "./Thg.vue?vue&type=script&lang=ts"
export * from "./Thg.vue?vue&type=script&lang=ts"
import style1 from "./Thg.vue?vue&type=style&index=1&id=150b5b06&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports